import { gsap } from "gsap";
//import Scrollbar from 'smooth-scrollbar';
import { ScrollTrigger } from "gsap/ScrollTrigger";
//import { ScrollSmoother } from "gsap/ScrollSmoother";
import { TextPlugin } from "gsap/TextPlugin";
class Ganimation {
    constructor() {
      gsap.registerPlugin(ScrollTrigger, TextPlugin );
/*
      const smoother = ScrollSmoother.create({
        content: ".wp-site-blocks",
        smooth: 3,
        effects: true
       });
       
       smoother.effects("img", { speed: "auto" });
*/       
       let welcomeText;
       let url = window.location.href.split('/');
        
        let jezyk = url[3];
        if (jezyk == "en"){
          welcomeText = "Always on time, <br> anywhere!";
        }else if(jezyk == "de"){
          welcomeText = "Immer pünktlich, <br> überall!";
        }else if(jezyk == "es"){
          welcomeText = "Siempre a tiempo, <br> en cualquier lugar.";
        }else{
          welcomeText = "Zawsze na czas, <br> w dowolnym miejscu!";
        }

       function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
       //d.setTime(d.getTime() + (60*1000));
        console.log("ciastko: "+cname+" wygasa: "+d);
        let expires = "expires="+d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      }
      
      function getCookie(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      }

      function checkCookie() {  
        let user = getCookie("animacja");       
        if (user != "") {        
          var TitleAnimAgain = gsap.timeline({});
          TitleAnimAgain.to(".home .loader", {autoAlpha: 0});
          TitleAnimAgain.to(".home .TitleAnimFirst span.kb-adv-text-inner", {duration: 0.4, text:welcomeText}); 
         

    } else {
      setCookie("animacja", "true", 1); 
      var TitleAnimFirst = gsap.timeline({});
      TitleAnimFirst.set(".home .TitleAnimFirst span.kb-svg-icon-wrap", {autoAlpha: 0, x: -200}); // hide initially
      TitleAnimFirst.set(".home .wp-block-kadence-infobox", {autoAlpha: 0, y: +200}); // hide initially
      TitleAnimFirst.set(".home .TitleAnimFirstImg", {autoAlpha: 0, x: 200});
      TitleAnimFirst.set(".home .TitleAnimFirstBg > .kt-inside-inner-col", {backgroundColor:"rgba(37, 107, 172, 0.0)"});
      TitleAnimFirst.set(".home .TitleAnimFirst span.kb-adv-text-inner", {color:"rgba(37, 107, 172)"});
      TitleAnimFirst.set(".home .headMenu", {autoAlpha: 0});      
      TitleAnimFirst.to(".home .TitleAnimFirst span.kb-svg-icon-wrap", { autoAlpha: 1, x: 0, rotate: 360, duration: 0.3});
      TitleAnimFirst.to(".home .loader", {autoAlpha: 0});
      TitleAnimFirst.to(".home .TitleAnimFirst span.kb-adv-text-inner", {duration: 4, text:welcomeText}); 
      TitleAnimFirst.to(".home .TitleAnimFirstBg > .kt-inside-inner-col", {backgroundColor:"rgba(37, 107, 172, 0.8)"});      
      TitleAnimFirst.to(".home .TitleAnimFirst span.kb-adv-text-inner", {color:"rgba(255, 255, 255)"});
      TitleAnimFirst.fromTo('body.home', {backgroundSize:"0%", backgroundPosition: "bottom" }, {backgroundSize:"100%", backgroundPosition: "top", duration: 0.5, ease: "power1.inOut"});
      TitleAnimFirst.to(".home .TitleAnimFirstImg", {duration: 0.1, autoAlpha: 1, x: 0, duration: 0.3});      
      TitleAnimFirst.to(".home .wp-block-kadence-infobox", {y: 0, stagger: 0.2, autoAlpha: 1 });
      TitleAnimFirst.to(".home .headMenu", {autoAlpha: 1, duration: 2}); 
    } 
  }
    checkCookie();
        }

        
};

export default Ganimation